module.exports = __webpack_public_path__ + "img/costal-4-1.d8da49d2.jpg";